{
  "config-sip-in-progress": "Your medical expense report is in progress.",
  "config-sip-in-expired": "Your saved medical expense report has expired. If you want to submit a Medical Expense Report (21P-8416), please submit a new expense report.",
  "config-sip-saved": "We saved your medical expense report",
  "config-saved-not-found": "Please start over to submit a medical expense report.",
  "config-saved-no-auth": "Please sign in again to resume your medical expense report.",
  "config-pre-submit-aria": "I confirm that the identifying information in this form is accurate and has been represented correctly. I have not and will not receive reimbursement for these expenses. I certify the information contained on this form and the attached addendums is a true representation of expenses I have paid.",

  "contact-title": "Your email address and phone number",
  "contact-phone-label": "Primary phone number",

  "relationship-title": "Which of these best describes you?",
  "relationship-veteran-label": "I’m a Veteran reporting unreimbursed medical expenses",
  "relationship-non-veteran-label": "I’m the spouse, dependent, or survivor of a Veteran reporting unreimbursed medical expenses",

  "claimant-name-title": "Your name",
  "claimant-name-description": "You aren’t required to fill in all fields, but we can review your application faster if you provide more information.",

  "mailing-address-title": "Your mailing address",
  "mailing-address-description": "We’ll send any important information about your application to this address.",
  "mailing-address-street2-label": "Apartment or unit number",
  "mailing-address-military-label": "I receive mail outside of the United States on a U.S. military base",

  "veteran-name-title": "Veteran’s name",

  "identification-title-veteran": "Your identification information",
  "identification-title-claimant": "Veteran’s identification information",
  "identification-description": "You must enter a Social Security number or VA file number.",

  "first-time-title": "Reporting expenses",
  "first-time-question": "Is this your first time reporting expenses?",

  "effective-dates-title": "Reporting period effective date",

  "reporting-period-title": "Reporting period dates",
  "reporting-period-start-date": "Start date",
  "reporting-period-end-date": "End date",

  "expenses-review-title": "Review the expenses you’re submitting",

  "array-cancel-add-title": "Cancel adding this %s?",
  "array-cancel-edit-title": "Cancel editing this %s?",
  "array-cancel-add-description": "If you cancel, we won’t add this expense to your list of %s. You’ll return to a page where you can add a new %s.",
  "array-cancel-add-yes": "Yes, cancel adding",
  "array-cancel-add-no": "No, continue adding",
  "array-cancel-edit-yes": "Yes, cancel editing",
  "array-cancel-edit-no": "No, continue editing",
  "array-delete-title": "Delete this %s?",
  "array-delete-description": "This will delete the information from your list of %s. You’ll return to a page where you can add a new %s.",
  "array-delete-no": "No, keep",
  "array-delete-yes": "Yes, delete",
  "array-item-name": "Expense %s: %s",

  "care-intro-title": "Care expenses",
  "care-type-title": "Type of care",
  "care-recipient-page-title": "Care recipient and provider name",
  "care-recipient-question": "Who’s the expense for?",
  "care-recipient-fullname": "Full name of the person who received care",
  "care-provider-question": "What’s the name of the care provider?",
  "care-dates-page-title": "Dates of care",
  "care-start-date": "Care start date",
  "care-end-date": "Care end date",
  "care-date-hint": "Enter 1 or 2 digits for the month and day and 4 digits for the year.",
  "care-no-end-date": "No end date",
  "care-cost-page-title": "Cost of care",
  "care-cost-card-title": "Cost of care for %s",
  "care-monthly-amount": "How much is the monthly payment?",
  "care-hourly-rate": "What is the care provider’s rate per hour?",
  "care-weekly-hours": "How many hours per week does the care provider work?",
  "care-weekly-hours-hint": "Enter the number of full hours only. Round down any extra minutes to the lowest hour.",

  "medical-intro-title": "Medical expenses",
  "medical-recipient-page-title": "Medical recipient and provider name",
  "medical-recipient-edit-description": "We’ll take you through each of the sections of this medical expense for you to review and edit.",
  "medical-recipient-question": "Who’s the expense for?",
  "medical-recipient-fullname": "Full name of the person who received care",
  "medical-provider-question": "Who receives the payment?",
  "medical-provider-hint": "For example: provider’s name or insurance company",
  "medical-purpose-page-title": "Expense purpose and date",
  "medical-purpose-question": "What’s the payment for?",
  "medical-payment-date": "What’s the date of the payment?",
  "medical-frequency-page-title": "Frequency and cost of care",
  "medical-frequency-question": "How often do you make this payment?",
  "medical-payment-amount": "How much is the payment?",

  "mileage-intro-title": "Mileage expenses",
  "mileage-summary-title": "Do you have a mileage expense to add?",
  "mileage-traveler-page-title": "Traveler information",
  "mileage-traveler-edit-description": "We’ll take you through each of the sections of this mileage expense for you to review and edit.",
  "mileage-traveler-question": "Who needed to travel?",
  "mileage-traveler-fullname": "Full name of the person who traveled",
  "mileage-destination-page-title": "Expense destination and date",
  "mileage-destination-question": "What was the destination?",
  "mileage-destination-clinic-description": "This would be a doctor’s office, dentist, or other outpatient medical provider.",
  "mileage-destination-other": "Describe the destination",
  "mileage-miles-traveled": "How many miles were traveled?",
  "mileage-travel-date": "What was the date of travel?",
  "mileage-reimbursement-page-title": "Expense reimbursement",
  "mileage-reimbursed-question": "Has this mileage been reimbursed by any other source?",
  "mileage-reimbursed-hint": "For example: a VA Medical Center",
  "mileage-reimbursed-amount": "How much money was reimbursed?",

  "supporting-documents-title": "Supporting documents",

  "upload-documents-title": "Upload your supporting documents",
  "upload-documents-file-title": "Select a file to upload",
  "upload-documents-file-hint": "You can upload a .pdf, .jpg, .jpeg, or .png file. Your file should be no larger than 50 MB (non-PDF) or 99 MB (PDF only)."
}
